import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../lib/authContext';

type Tab = 'giris' | 'kayit';

export default function AuthPage() {
  const navigate = useNavigate();
  const { signIn, signUp } = useAuth();

  const [tab, setTab] = useState<Tab>('giris');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);
    try {
      if (tab === 'giris') {
        const { error } = await signIn(email, password);
        if (error) { setError(error); return; }
        navigate('/dashboard');
      } else {
        const { error } = await signUp(email, password);
        if (error) { setError(error); return; }
        setSuccess('Kayıt başarılı! Lütfen e-posta adresinizi doğrulayın.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-teal-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-teal-400 to-cyan-600 rounded-2xl mb-4 shadow-lg shadow-teal-500/30">
            <i className="ri-tooth-line text-white text-3xl"></i>
          </div>
          <h1 className="text-2xl font-bold text-white">ImpLog</h1>
          <p className="text-slate-400 text-sm mt-1">İmplant Takip Sistemi</p>
        </div>

        <div className="bg-slate-800/60 backdrop-blur border border-slate-700/50 rounded-2xl p-6 shadow-2xl">
          <div className="flex mb-6 bg-slate-900/60 rounded-xl p-1 gap-1">
            {(['giris', 'kayit'] as Tab[]).map((t) => (
              <button
                key={t}
                onClick={() => { setTab(t); setError(null); setSuccess(null); }}
                className={`flex-1 py-2 text-sm font-semibold rounded-lg transition-all cursor-pointer ${
                  tab === t
                    ? 'bg-gradient-to-r from-teal-500 to-cyan-600 text-white shadow'
                    : 'text-slate-400 hover:text-white'
                }`}
              >
                {t === 'giris' ? 'Giriş Yap' : 'Kayıt Ol'}
              </button>
            ))}
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-slate-300 text-sm font-medium mb-1.5">E-posta</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="ornek@email.com"
                className="w-full bg-slate-900/60 border border-slate-600 text-white rounded-xl px-4 py-2.5 text-sm placeholder-slate-500 focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500 transition"
              />
            </div>
            <div>
              <label className="block text-slate-300 text-sm font-medium mb-1.5">Şifre</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength={6}
                placeholder="En az 6 karakter"
                className="w-full bg-slate-900/60 border border-slate-600 text-white rounded-xl px-4 py-2.5 text-sm placeholder-slate-500 focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500 transition"
              />
            </div>

            {error && (
              <div className="flex items-start gap-2 bg-red-500/10 border border-red-500/30 rounded-xl px-4 py-3">
                <i className="ri-error-warning-line text-red-400 mt-0.5 flex-shrink-0"></i>
                <p className="text-red-300 text-sm">{error}</p>
              </div>
            )}

            {success && (
              <div className="flex items-start gap-2 bg-teal-500/10 border border-teal-500/30 rounded-xl px-4 py-3">
                <i className="ri-checkbox-circle-line text-teal-400 mt-0.5 flex-shrink-0"></i>
                <p className="text-teal-300 text-sm">{success}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-gradient-to-r from-teal-500 to-cyan-600 text-white rounded-xl font-semibold hover:from-teal-600 hover:to-cyan-700 transition-all disabled:opacity-60 flex items-center justify-center gap-2 cursor-pointer mt-2"
            >
              {loading ? (
                <><div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>Bekleniyor...</>
              ) : (
                <>{tab === 'giris' ? 'Giriş Yap' : 'Hesap Oluştur'}</>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
